import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CardExibirPdf from "../../../components/CardExibirPDF";
import CardSeplag from "../../../components/CardSeplag";
import {
  carregarArvoreRagComFiltro,
  carregarArvoreRagPermissao,
  gerarRelatorioRagProrrogacao,
  listarOrgaosParaContaAcesso,
  listarOrgaosPermissao,
  listarVisaoParamExercRag,
} from "../../../service/Rag/ArvoreRag";

import download from "downloadjs";
import { getAllProgramaV1 } from "../../../service/Rag/Exercicio";

import { printToast } from "../../../config/global";
import "./style.css";
const RelatorioProrrogacao = () => {
  const [filtros, setFiltros] = useState({
    exercicioSelecionado: null,
    orgaoSelecionado: null,
    uoSelecionada: null,
    programaSelecionado: [],
    tipoRelatorioSelecionado: { name: "PDF", code: "P" },
    acaoSelecionada: [],
    exibirRelatorio: false,
    isExibirPDF: false,
  });
  const [cDados, setCDados] = useState({
    cDadosArvore: [],
    cDadosExercicios: [],
    cDadosUOs: [],
    cDadosOrgaos: [],
    cDadosProdutos: [],
    cDadosProgramas: [],
    cDadosCiclo: [],
    cDadosAcoes: [],
    tipoRelatorio: [
      { name: "PDF", code: "P" },
      { name: "EXCEL", code: "E" },
    ],
    tituloPDF: "",
    dadosRelatorioBase64: null,
  });
  const user = useSelector((state) => state.userReducer.user);
  const [perfis] = useState({
    MONRL_ADMIN_CENTRAL: buscarPerfil("MONRL_ADMIN_CENTRAL"),
    MONRL_ANALISTA: buscarPerfil("MONRL_ANALISTA"),
    MONRL_ACESSO_ORGAO_CONTROLE: buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE"),
  });

  useEffect(() => {
    if (user) {
      buscarExercicio();
    }
  }, [user]);

  const defaultArvoreMonitora = {
    arvorePtaMonitoras: cDados.cDadosArvore,
    listaExercicios: cDados.cDadosExercicios,
    parametroExercicio: cDados.cDadosCiclo,
    orgaoFiplans: cDados.cDadosOrgaos,
    unidadeOrcamentarias: cDados.cDadosUOs,
    programas: cDados.cDadosProgramas,
    produto: cDados.cDadosProdutos,
  };

  const buscarExercicio = async () => {
    await listarVisaoParamExercRag().then((data) => {
      setCDados((prevState) => ({ ...prevState, cDadosExercicios: data != null ? data : null }));
    });
  };

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  const onChangeExercicio = async (e) => {
    if (e.value !== null) {
      setFiltros((prevState) => ({
        ...prevState,
        exercicioSelecionado: e.value,
        orgaoSelecionado: null,
        programaSelecionado: null,
        uoSelecionada: null,
      }));
      setCDados((prevState) => ({ ...prevState, cDadosOrgaos: null, cDadosUOs: null }));

      if (Object.values(perfis).some((value) => value === true)) {
        await await listarOrgaosParaContaAcesso(e.value.exercicio.idenExercicio).then((data) => {
          setCDados((prevState) => ({ ...prevState, cDadosOrgaos: data != null ? data : null }));
        });
      } else {
        await listarOrgaosPermissao(e.value.exercicio.idenExercicio).then((data) => {
          setCDados((prevState) => ({ ...prevState, cDadosOrgaos: data != null ? data : null }));
        });
      }
    }
  };

  const onChangeUo = async (e) => {
    if (e.value && e.value.length > 0) {
      setFiltros((prevState) => ({ ...prevState, uoSelecionada: e.value }));

      // Obtém os programas para todas as UOs selecionadas
      const promises = e.value.map((uo) => getAllProgramaV1(filtros.orgaoSelecionado.idenOrgao, uo.idenUo));

      const responses = await Promise.all(promises);
      const programas = responses.map((res) => (res?.data?.content ? res.data.content : [])).flat();

      setCDados((prevState) => ({
        ...prevState,
        cDadosProgramas: programas,
      }));
    } else {
      // Se não houver UO selecionada, limpar os programas e filtros relacionados
      setFiltros((prevState) => ({
        ...prevState,
        uoSelecionada: null,
        programaSelecionado: [],
        acaoSelecionada: null,
      }));

      setCDados((prevState) => ({
        ...prevState,
        cDadosProgramas: [],
      }));
    }
  };

  const onChangeOrgao = async (e) => {
    if (e.value !== undefined) {
      let orgao = e.value ? e.value : e;

      setFiltros((prevState) => ({
        ...prevState,
        orgaoSelecionado: e.value,
        uoSelecionada: null,
        programaSelecionado: [],
        acaoSelecionada: null,
      }));

      setCDados((prevState) => ({
        ...prevState,
        cDadosUOs: null,
        cDadosProgramas: null,
        cDadosProdutos: null,
        cDadosArvore: null,
      }));

      let filtro = {
        idenExercicio: filtros.exercicioSelecionado.idenExercicio,
        idenOrgao: orgao.idenOrgao,
        idenUo: null,
        idenPrograma: null,
        idenProduto: null,
      };
      let eager = true;

      if (Object.values(perfis).some((value) => value === true)) {
        await carregarArvoreRagComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
          setCDados((prevState) => ({
            ...prevState,
            cDadosCiclo: res.parametroExercicio,
            cDadosOrgaos: res.orgaoFiplans,
            cDadosUOs: res.unidadeOrcamentarias,
          }));
        });
      } else {
        await carregarArvoreRagPermissao(filtro, defaultArvoreMonitora, eager).then((res) => {
          setCDados((prevState) => ({
            ...prevState,
            cDadosCiclo: res.parametroExercicio,
            cDadosOrgaos: res.orgaoFiplans,
            cDadosUOs: res.unidadeOrcamentarias,
          }));
        });
      }
    } else {
      setFiltros((prevState) => ({
        ...prevState,
        orgaoSelecionado: null,
        uoSelecionada: null,
        programaSelecionado: [],
        acaoSelecionada: null,
      }));
    }
  };

  const onChangePrograma = (e) => {
    if (e.value !== null) {
      setFiltros((prevState) => ({ ...prevState, programaSelecionado: e.value }));
      const allChildren = e.value.flatMap((item) => item.children || []);
      setCDados((prevState) => ({ ...prevState, cDadosAcoes: allChildren }));
      return;
    }
  };

  const onChangeAcao = (e) => {
    setFiltros((prevState) => ({ ...prevState, acaoSelecionada: e.value }));
  };

  function validarCampos() {
    if (filtros.exercicioSelecionado == null) {
      return "O ‘Exercício’  deve ser informado";
    }
  }

  const gerarRelatorio = () => {
    const validacaoErro = validarCampos();
    if (validacaoErro) {
      printToast({
        severity: "error",
        detail: validacaoErro,
      });
      return;
    }

    let listaIdenPrograma = filtros.programaSelecionado
      ? filtros.programaSelecionado.map((element) => element.programa.idenPrograma)
      : [];
    let idenOrgao = filtros.orgaoSelecionado?.idenOrgao == null ? null : filtros.orgaoSelecionado.idenOrgao;
    let listaUnidOrcamentaria = filtros.uoSelecionada ? filtros.uoSelecionada.map((element) => element.idenUo) : [];

    let idenUo = listaUnidOrcamentaria[0];

    let idenExercicio = filtros.exercicioSelecionado ? filtros.exercicioSelecionado.exercicio.idenExercicio : 0;
    let tipoRelatorio =
      filtros.tipoRelatorioSelecionado && filtros.tipoRelatorioSelecionado != null
        ? filtros.tipoRelatorioSelecionado.code
        : null;
    let listaAcoes = filtros.acaoSelecionada ? filtros.acaoSelecionada.map((element) => element.idView) : [];
    let listaPtaFiplan = filtros.acaoSelecionada ? filtros.acaoSelecionada.map((element) => element.idenPtaFiplan) : [];

    let JsonBody = {
      idenExercicio,
      idenOrgao,
      idenUo,
      listaUnidOrcamentaria,
      listaIdenPrograma,
      listaAcoes,
      tipoRelatorio,
      listaPtaFiplan,
    };

    gerarRelatorioRagProrrogacao(JsonBody).then((res) => {
      if (filtros.tipoRelatorioSelecionado.code === "W") {
        download(
          `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
          `${res.data.nomeArquivo}`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      } else {
        //download(`data:application/pdf;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}.pdf`, "application/pdf");
        let valorMb = res.data.dadosRelatorioBase64.length / 1024000;
        if (valorMb > 2) {
          //this.$toast.add({severity:'warn', summary: 'Tamanho excessivo', detail:"Devido ao tamanho do arquivo, realizou-se o download do relatório.", life: 5000});
          download(
            `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/pdf"
          );
        } else {
          download(
            `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/pdf"
          );

          setCDados((prevState) => ({
            ...prevState,
            tituloPDF: res.data.nomeArquivo,
            dadosRelatorioBase64: res.data.dadosRelatorioBase64,
          }));
          if (filtros.exibirRelatorio.code === "P") {
            setFiltros((prevState) => ({ ...prevState, isExibirPDF: true }));
          }
        }
      }
    });
  };

  function fecharJanela() {
    setFiltros((prevState) => ({
      ...prevState,
      exibirRelatorio: false,
      isExibirPDF: false,
    }));
  }

  const onChangeTipoRelatorio = (e) => {
    setFiltros((prevState) => ({ ...prevState, tipoRelatorioSelecionado: e.value }));
  };
  const itemTemplateAcoes = (option) => {
    if (option) {
      return (
        <>
          <span>
            {" "}
            {option.codFiplanItem} - {option.descricaoItem}
          </span>
        </>
      );
    }
  };

  return (
    <CardSeplag title="RAG: RELATÓRIO DE PRORROGAÇÕES">
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown
                  emptymessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selExercicio"
                  value={filtros.exercicioSelecionado}
                  options={cDados.cDadosExercicios}
                  onChange={onChangeExercicio}
                  optionLabel="exercicio.ano"
                  placeholder="Selecione um exercício"
                  display="chip"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selOrgao"
                  value={filtros.orgaoSelecionado}
                  options={cDados.cDadosOrgaos}
                  onChange={onChangeOrgao}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Órgão"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selUo">Unidade Orçamentária</label>
                <MultiSelect
                  emptymessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selUo"
                  value={filtros.uoSelecionada}
                  options={cDados.cDadosUOs}
                  onChange={onChangeUo}
                  key="option.idenUo"
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Todas"
                  display="chip"
                />
              </span>
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label htmlFor="selPro">Programas</label>
              <MultiSelect
                emptymessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selPro"
                value={filtros.programaSelecionado}
                options={cDados.cDadosProgramas}
                onChange={onChangePrograma}
                key="option.programa.idenPrograma"
                optionLabel="programa.descricaoFiplan"
                filter
                filterBy="programa.descricaoFiplan"
                placeholder="Selecione um Programa"
                display="chip"
              />
            </div>

            <div className="field col-12 md:col-4 ">
              <label htmlFor="selAcoes">Ações</label>
              <MultiSelect
                emptymessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selAcoes"
                value={filtros.acaoSelecionada}
                options={cDados.cDadosAcoes}
                onChange={onChangeAcao}
                key="option.idView"
                optionLabel="descricaoItem"
                filter
                filterBy="descricaoItem"
                placeholder="Selecione uma Ação"
                itemTemplate={itemTemplateAcoes}
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
              <Dropdown
                id="selTipo"
                value={filtros.tipoRelatorioSelecionado}
                options={cDados.tipoRelatorio}
                onChange={onChangeTipoRelatorio}
                optionLabel="name"
                placeholder="Selecione um Tipo de Impressão de Relatório"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-2">
        <Button type="button" label="Gerar" icon="pi pi-file-pdf" className="col-3 col-12" onClick={gerarRelatorio} />
      </div>
      {filtros.isExibirPDF && (
        <CardExibirPdf
          tamanhoTela="'85.vw'"
          alturaTela="'350.vh'"
          stringPDF={"data:application/pdf;base64," + cDados.dadosRelatorioBase64}
          tituloTela={cDados.tituloPDF}
          isExibirPDF={filtros.isExibirPDF}
          position="center"
          onHide={fecharJanela}
        />
      )}
    </CardSeplag>
  );
};
export default RelatorioProrrogacao;
